import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_pagination = _resolveComponent("pagination");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_input, {
    placeholder: "请输入内容",
    modelValue: _ctx.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.name = $event),
    class: "input-search",
    size: "mini"
  }, {
    append: _withCtx(() => [_createVNode(_component_el_button, {
      icon: "el-icon-search",
      onClick: $setup.queryHandler
    }, null, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.tableData,
    size: "small",
    onSelectionChange: $setup.selectionChange,
    onRowClick: $setup.rowClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "selection",
      width: "55"
    }), _createVNode(_component_el_table_column, {
      prop: "name",
      label: "名称"
    }), _createVNode(_component_el_table_column, {
      prop: "name",
      label: "类型"
    }, {
      default: _withCtx(({
        row
      }) => [row.nodeTyp === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_1, "收藏夹")) : _createCommentVNode("", true), row.nodeTyp === '1' ? (_openBlock(), _createElementBlock("span", _hoisted_2, "素材")) : _createCommentVNode("", true), row.nodeTyp === '2' ? (_openBlock(), _createElementBlock("span", _hoisted_3, "需求")) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "createTime",
      label: "创建时间"
    })]),
    _: 1
  }, 8, ["data", "onSelectionChange", "onRowClick"])), [[_directive_loading, _ctx.loading]]), _createVNode(_component_el_button, {
    size: "small",
    type: _ctx.selectedIds.length ? 'danger' : 'info',
    disabled: !_ctx.selectedIds.length,
    icon: "el-icon-delete",
    circle: "",
    onClick: $setup.deleteHandler
  }, null, 8, ["type", "disabled", "onClick"]), _createVNode(_component_pagination, {
    total: _ctx.total
  }, null, 8, ["total"])], 64);
}